import React, { Component } from 'react';

class Mandatory extends Component {
    render() {
        return (
            <span className="text-darkred">*</span>
        );
    }
}

export default Mandatory;